import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22index.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22./SpaceGrotesk-Variable.woff2%22,%22weight%22:%22300%20700%22,%22display%22:%22swap%22,%22variable%22:%22--font-landing-mono%22}],%22variableName%22:%22landingMono%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'landingMono', 'landingMono Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
